const FILTER_KEYS = [
  'country',
  'area',
  'industry',
  'tags',
  'outlet_text',
  'has_email',
  'has_phone_number',
  'kind_of_journalist',
];

const hasMeaningfulFilters = (filters = {}) => FILTER_KEYS.some((key) => {
  const value = filters[key];
  if (Array.isArray(value)) return value.length > 0;
  return value !== null && value !== undefined && value !== '';
});

const canRunJournalistSearch = ({ query, filters, hasFullAccess }) => {
  const hasQuery = String(query || '').trim().length >= 3;
  return hasQuery || (hasFullAccess && hasMeaningfulFilters(filters));
};

module.exports = {
  canRunJournalistSearch,
  hasMeaningfulFilters,
};
